import {useMutation} from "@tanstack/react-query";
import {removePermissionFromRoleMutationOptions} from "./remove-permission-from-role.mutation-options";

export function useRemovePermissionFromRole(roleId: string) {
  return useMutation(removePermissionFromRoleMutationOptions(roleId));
}
